var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.clinicId)?_c('ClinicDoctors',{attrs:{"clinic-id":_vm.clinicId}}):_c('v-alert',{attrs:{"type":"warning","outlined":""}},[_vm._v(" No clinic selected ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }